import { render, staticRenderFns } from "./StocktakingAdminView.vue?vue&type=template&id=401f1ff6&"
import script from "./StocktakingAdminView.vue?vue&type=script&lang=js&"
export * from "./StocktakingAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports